var render = function render(_c, _vm) {
  return _c("div", { staticClass: "ruler" }, [
    _c(
      "div",
      {
        staticClass: "query",
        class: { reversed: _vm.props.start > _vm.props.end },
        style: {
          left:
            ((Math.min(_vm.props.start, _vm.props.end) - 1) /
              _vm.props.length) *
              100 +
            "%",
          right:
            100 -
            (Math.max(_vm.props.start, _vm.props.end) / _vm.props.length) *
              100 +
            "%",
        },
      },
      [
        _c("div", {
          staticClass: "chevron-start",
          style: { "background-color": _vm.props.color },
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "chevron-mid",
          style: { "background-color": _vm.props.color },
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "chevron-end",
          style: { "background-color": _vm.props.color },
        }),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "tick-label",
        style: {
          left:
            ((Math.min(_vm.props.start, _vm.props.end) - 1) /
              _vm.props.length) *
              100 +
            "%",
        },
      },
      [_vm._v(_vm._s(Math.min(_vm.props.start, _vm.props.end)))]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "tick-label",
        style: {
          right:
            100 -
            (Math.max(_vm.props.start, _vm.props.end) / _vm.props.length) *
              100 +
            "%",
          "margin-left": 0,
          "margin-right": "-25px",
        },
      },
      [_vm._v(_vm._s(Math.max(_vm.props.start, _vm.props.end)))]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }